import React from 'react';
import CabCrudPage from './CabCrudPage';
import { uploadAdminAsset } from '../../../api/cabsHomepageAdmin';

const AdminCabsGuestTrips = () => (
  <CabCrudPage
    title="Guest Trips"
    description="Manage guest trip highlight cards."
    resource="guest-trips"
    uploadHandler={uploadAdminAsset}
    enableReorder
    defaultItem={{
      title: '',
      caption: '',
      location: '',
      tripDate: '',
      imageUrl: '',
      sortOrder: 0,
      isActive: true,
    }}
    columns={[
      { key: 'title', label: 'Title' },
      { key: 'location', label: 'Location' },
      { key: 'tripDate', label: 'Trip date' },
    ]}
    fields={[
      { name: 'title', label: 'Title', required: true },
      { name: 'caption', label: 'Caption', type: 'textarea', rows: 2 },
      { name: 'location', label: 'Location' },
      { name: 'tripDate', label: 'Trip date', type: 'date' },
      { name: 'imageUrl', label: 'Image', type: 'image', required: true },
      { name: 'sortOrder', label: 'Sort order', type: 'number' },
      { name: 'isActive', label: 'Active', type: 'checkbox', col: 'col-md-6' },
    ]}
  />
);

export default AdminCabsGuestTrips;
